import Vue from 'vue'
import Router from './router'
import Store from './store'

// import io from '../libs/sailsjs/sails.io.js'
// Vue.use(io)
// help - https://www.npmjs.com/package/vue-sails.io
// import VueSailsIO from 'vue-sails.io'
// Vue.use(VueSailsIO, 'http://no_url') // no url is known at the moment; пустым второй параметр нельзя оставлять тогда ошибка в console выдется
// Vue.use(VueSailsIO, 'http://localhost:1778') // no url is known at the moment; пустым второй параметр нельзя оставлять тогда ошибка в console выдется

import iView from '../libs/iview'
import '../libs/iview/dist/styles/iview.css'
import iViewLocale from '../libs/iview/dist/locale/ru-RU.js'
Vue.use(iView, {locale: iViewLocale})

import ElementUI from '../libs/element-ui'
// import '../libs/element-ui/lib/theme-default/index.css'
import '../libs/element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

import '../libs/bootstrap/dist/css/bootstrap.min.css'
// import '../libs/font-awesome/css/font-awesome.min.css'
import '../libs/font-awesome/css/all.min.css'
import '../libs/font-awesome/css/regular.min.css'
import '../libs/font-awesome/css/solid.min.css'

// import VueApexCharts from 'vue-apexcharts'
// Vue.use(VueApexCharts)
// Vue.component('apexchart', VueApexCharts)

// import jQ from '@/../libs/jquery-3.3.1/jquery.min.js'
// Vue.use(jQ)
// import ckeditor from 'ckeditor'
// Vue.use(ckeditor)

import numeral from 'numeral'

import http from 'axios'
http.defaults.withCredentials = true // нужно чтобы потом все requests к cross-origin-серверу проходили с куки и следовательно с куки авторизованной сессии

function cloneObject (obj) { // не предназначен для входного array !!!
  if (obj == null) return null
  var newObj = {}
  for (var key in obj) {
    if (obj[key] == null) { // надо так как в доке написано что typeof null == "object" а нам это не надо иначе запустим cloneObject
      newObj[key] = obj[key]
    } else if (typeof obj[key] === 'object') {
      newObj[key] = cloneObject(obj[key])
    } else {
      newObj[key] = obj[key]
    }
  }
  return newObj
}
function cloneObjectWithoutFns (obj) {
  if (obj == null) return null
  var newObj = {}
  for (var key in obj) {
    if (obj[key] == null) { // надо так как в доке написано что typeof null == "object" а нам это не надо иначе запустим cloneObject
      newObj[key] = obj[key]
    } else if (typeof obj[key] === 'object') {
      newObj[key] = cloneObject(obj[key])
    } else if (typeof obj[key] === 'function') {
      // skip this prop
    } else {
      newObj[key] = obj[key]
    }
  }
  return newObj
}

const weekDaysNames = ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб']
Vue.filter('formatDate', function (value, format) {
  // console.log(value)
  if (value) {
    var result = ''
    value = new Date(value)
    if ((format == null) || (format === 'date')) {
      if (value.getDate() < 10) { result += '0' }
      var month = value.getMonth() + 1; if (month < 10) month = '0' + month
      return result + value.getDate() + '.' + month + '.' + value.getFullYear()
    }
    if (format === 'month') {
      month = value.getMonth() + 1; if (month < 10) month = '0' + month
      return month + '.' + value.getFullYear()
    }
    if (format === 'day + weekday') {
      if (value.getDate() < 10) { result += '0' }
      return result + value.getDate() + ', ' + weekDaysNames[value.getDay()]
    }
    if (format === 'date + time') {
      if (value.getDate() < 10) { result += '0' }
      month = (value.getMonth() + 1) >= 10 ? (value.getMonth() + 1) : ('0' + (value.getMonth() + 1))
      var hours = value.getHours(); if (hours < 10) hours = '0' + hours
      var minutes = value.getMinutes(); if (minutes < 10) minutes = '0' + minutes
      var seconds = value.getSeconds(); if (seconds < 10) seconds = '0' + seconds
      return result + value.getDate() + '.' + month + '.' + value.getFullYear() + ' ' + hours + ':' + minutes + ':' + seconds
    }
    if (format === 'timeWithoutSeconds') {
      hours = value.getHours(); if (hours < 10) hours = '0' + hours
      minutes = value.getMinutes(); if (minutes < 10) minutes = '0' + minutes
      return hours + ':' + minutes
    }
    // return moment(String(value), 'ddd MMM DD YYYY' /* здесь формат входных данных - нужен для momentjs для правильного парсинга */).format('DD, ddd')
    // return moment.tz(String(value), 'Europe/Moscow').format('DD, ddd')
  }
})

numeral.register('locale', 'ru', {
  delimiters: {
    thousands: ' ',
    decimal: ','
  }
})
// numeral.locale('en')
Vue.filter('money', function (value) {
  if (value === null) return null
  if (value === '') return ''
  // return numeral(value).format('0.0')
  var res = ''
  var str = Math.round(value).toString()

  while (str.length > 3) {
    res = ' ' + str.substring(str.length - 3, str.length) + res
    str = str.slice(0, -3)
  }
  res = str + res
  return res
})
Vue.filter('moneyWithSign', function (value) {
  if (value === null) return null
  if (value === '') return ''
  // return numeral(value).format('0.0')

  function isNumber (value) {
    return (value instanceof Number || typeof value === 'number') && !isNaN(value)
  }
  if (isNumber(value) !== true) return value

  var res = ''
  var str = Math.round(value).toString()

  while (str.length > 3) {
    res = ' ' + str.substring(str.length - 3, str.length) + res
    str = str.slice(0, -3)
  }
  res = str + res
  if (value > 0) res = '+ ' + res
  if (value < 0) res = '- ' + res.substring(1, res.length)
  return res
})
Vue.filter('moneyWithCentsWithSign', function (value) {
  if (value === null) return null
  if (value === '') return ''
  function isNumber (value) {
    return (value instanceof Number || typeof value === 'number') && !isNaN(value)
  }
  if (isNumber(value) !== true) return value

  var res = ''
  var str = (Math.round(value * 100) / 100).toString()
  var dotPosition = str.indexOf('.')
  var cents = ''
  if (dotPosition >= 0) {
    cents = str.substring(dotPosition, str.length)
    str = str.substring(0, dotPosition)
  }

  while (str.length > 3) {
    res = ' ' + str.substring(str.length - 3, str.length) + res
    str = str.slice(0, -3)
  }
  res = str + res
  res = res + cents

  if (value > 0) res = '+ ' + res
  if (value < 0) res = '- ' + res.substring(1, res.length)

  return res
})
Vue.filter('moneyWithCents', function (value) {
  if (value === null) return null
  if (value === '') return ''
  function isNumber (value) {
    return (value instanceof Number || typeof value === 'number') && !isNaN(value)
  }
  if (isNumber(value) !== true) return value

  var res = ''
  var str = (Math.round(value * 100) / 100).toString()
  var dotPosition = str.indexOf('.')
  var cents = ''
  if (dotPosition >= 0) {
    cents = str.substring(dotPosition, str.length)
    str = str.substring(0, dotPosition)
  }

  while (str.length > 3) {
    res = ' ' + str.substring(str.length - 3, str.length) + res
    str = str.slice(0, -3)
  }
  res = str + res
  res = res + cents
  return res
})

Vue.component('InputMoney', {
  props: ['value'],
  template: `
      <div style="width:100%; height:100%;">
          <div ref="unselect" tabindex=0></div>
          <input v-model="displayValue" @blur="isInputActive = false" @focus="isInputActive = true" @keydown="onKeyDown" class="input_money"/>
      </div>`,
  data: function () {
    return {
      isInputActive: false
    }
  },
  mounted: function () {
    var cssText = `
      .input_money{width:100%; height:100%; border: 1px solid #dddee1; border-radius: 4px; padding: 4px 7px 4px 7px;}
      .input_money:focus{
        outline:none !important; border-color:#9098c0; box-shadow:0 0 5px #ccc;
        transition: border .2s ease-in-out,background .2s ease-in-out,box-shadow .2s ease-in-out;
        transition-property: border, background, box-shadow;
        transition-duration: 0.2s, 0.2s, 0.2s;
        transition-timing-function: ease-in-out, ease-in-out, ease-in-out;
        transition-delay: 0s, 0s, 0s
      }
      .input_money:hover{
        border-color:#9098c0;
        transition: border .2s ease-in-out,background .2s ease-in-out,box-shadow .2s ease-in-out;
        transition-property: border, background, box-shadow;
        transition-duration: 0.2s, 0.2s, 0.2s;
        transition-timing-function: ease-in-out, ease-in-out, ease-in-out;
        transition-delay: 0s, 0s, 0s
      }
    `
    var css = document.createElement('style')
    css.type = 'text/css'
    css.setAttributeNode(document.createAttribute('scopped'))
    css.appendChild(document.createTextNode(cssText))
    this.$el.appendChild(css)
  },
  methods: {
    onKeyDown: function (event) {
      // console.log(event)
      if ((event.keyCode === 8 /* backspace */) ||
          (event.keyCode === 39 /* arrow right */) ||
          (event.keyCode === 37 /* arrow left */) ||
          (event.keyCode === 46 /* delete */)) {
      } else if (event.keyCode === 13) {
        this.$refs.unselect.focus()
      } else if ((event.keyCode < 48) || (event.keyCode > 57)) event.preventDefault() // не даем вводить не цифры
    }
  },
  computed: {
    displayValue: {
      get: function () {
        var res = ''
        var str = this.value
        if (this.isInputActive) {
          // Cursor is inside the input field. unformat display value for user
          return this.value
          /* res = ''
          str = this.value
          while (str.length > 3) {
            res = ' ' + str.substring(str.length - 3, str.length) + res
            str = str.slice(0, -3)
          }
          res = str + res
          return res */
        } else {
          res = ''
          str = this.value
          while (str.length > 3) {
            res = ' ' + str.substring(str.length - 3, str.length) + res
            str = str.slice(0, -3)
          }
          res = str + res
          return res
        }
      },
      set: function (modifiedValue) {
        let newValue = modifiedValue
        if (modifiedValue == null) newValue = ''
        if (typeof modifiedValue !== 'string') newValue = modifiedValue.toString()
        // newValue и modifiedValue - сейчас содержат все пробелы и другие символы, удалем их и устанвливаем в this.value через $emit
        newValue = newValue.replace(/[^\d.]/g, '')
        // Note: we cannot set this.value as it is a "prop". It needs to be passed to parent component
        // $emit the event so that parent component gets it
        this.$emit('input', newValue)
      }
    }
  }
})

Vue.component('InputJSON', {
  props: ['value', 'rows'],
  template: `
      <div style="width:100%; height:100%;">
          <div ref="unselect" tabindex=0></div>
          <textarea v-model="displayValue" :rows="rows" @blur="isInputActive = false" @focus="isInputActive = true" @keydown="onKeyDown" class="input_json"/>
      </div>`,
  data: function () {
    return {
      isInputActive: false
    }
  },
  mounted: function () {
    var cssText = `
      .input_json{width:100%; height:100%; border: 1px solid #dddee1; border-radius: 4px; padding: 4px 7px 4px 7px;}
      .input_json:focus{
        outline:none !important; border-color:#9098c0; box-shadow:0 0 5px #ccc;
        transition: border .2s ease-in-out,background .2s ease-in-out,box-shadow .2s ease-in-out;
        transition-property: border, background, box-shadow;
        transition-duration: 0.2s, 0.2s, 0.2s;
        transition-timing-function: ease-in-out, ease-in-out, ease-in-out;
        transition-delay: 0s, 0s, 0s
      }
      .input_json:hover{
        border-color:#9098c0;
        transition: border .2s ease-in-out,background .2s ease-in-out,box-shadow .2s ease-in-out;
        transition-property: border, background, box-shadow;
        transition-duration: 0.2s, 0.2s, 0.2s;
        transition-timing-function: ease-in-out, ease-in-out, ease-in-out;
        transition-delay: 0s, 0s, 0s
      }
    `
    var css = document.createElement('style')
    css.type = 'text/css'
    css.setAttributeNode(document.createAttribute('scopped'))
    css.appendChild(document.createTextNode(cssText))
    this.$el.appendChild(css)
  },
  methods: {
    onKeyDown: function (event) {
      // if ((event.keyCode === 8 /* backspace */) ||
      //     (event.keyCode === 39 /* arrow right */) ||
      //     (event.keyCode === 37 /* arrow left */) ||
      //     (event.keyCode === 46 /* delete */)) {
      // } else if (event.keyCode === 13) {
      //   this.$refs.unselect.focus()
      // } else if ((event.keyCode < 48) || (event.keyCode > 57)) event.preventDefault() // не даем вводить не цифры
    }
  },
  computed: {
    displayValue: {
      get: function () {
        // var res = ''
        // var str = this.value
        if (this.isInputActive) {
          // return this.value
          return JSON.stringify(this.value, null, '\t')
        } else {
          // return this.value
          return JSON.stringify(this.value, null, '\t')
        }
      },
      set: function (modifiedValue) {
        let newValue = modifiedValue
        if (modifiedValue == null) newValue = ''
        if (typeof modifiedValue !== 'string') newValue = modifiedValue.toString()
        // newValue и modifiedValue - сейчас содержат все пробелы и другие символы, удалем их и устанвливаем в this.value через $emit
        // newValue = newValue.replace(/[^\d.]/g, '')
        // Note: we cannot set this.value as it is a "prop". It needs to be passed to parent component
        // $emit the event so that parent component gets it
        newValue = JSON.parse(newValue)
        // кидаем событие вверх на уровень InputJSON
        this.$emit('input', newValue)
      }
    }
  }
})

Vue.config.productionTip = false
Vue.config.devtools = process.env.NODE_ENV !== 'production' // инструкция запрещает vue dev tool debugger открываться на этой странице если значение false

import App from './App'

/* eslint-disable no-new */
const app = new Vue({
  el: '#application',
  router: Router,
  store: Store,
  template: '<App/>',
  components: { App }
})

// для DEBUG ONLY - чтобы в браузерной консоли можно было менять данные у компонент.
// например команда: window.app.$store.commit('appStateServerConnectedSet', true)
window.app = app

window.cloneObject = cloneObject
window.cloneObjectWithoutFns = cloneObjectWithoutFns



// WEBPACK FOOTER //
// ./src/main.js